import { useClearAllState, useSetShowSettingsPopup, useShowSettingsPopup } from '../store/hooks';

import { ProjectManagerCard } from './ProjectManagerCard';
import { SettingsButton } from './SettingsButton';
import { SettingsPopup } from './SettingsPopup';
import { UnifiedBottomBar } from './UnifiedBottomBar';
import { UnifiedTopBar } from './UnifiedTopBar';

export default function ProjectManager() {
  const showSettingsPopup = useShowSettingsPopup();
  const setShowSettingsPopup = useSetShowSettingsPopup();
  const clearAllState = useClearAllState();

  const handleRestartFlow = () => {
    clearAllState();
    window.location.href = '/';
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-b from-[#050614] to-[#0f1a2f] flex flex-col">
      <UnifiedTopBar subtitle="Project Manager" actions={<SettingsButton />} />
      <div className="p-4 flex flex-col gap-4 flex-1 overflow-auto">
        <div className="max-w-4xl mx-auto w-full space-y-4">
          <ProjectManagerCard />
        </div>
      </div>
      <UnifiedBottomBar
        variant="planner"
        onBack={handleRestartFlow}
        onContinue={() => {}}
        canContinue={false}
        showBack
        showUndo={false}
        showRedo={false}
        showClear={false}
        showActionsSeparator={false}
        showContinue={false}
      />
      <SettingsPopup isOpen={showSettingsPopup} onClose={() => setShowSettingsPopup(false)} />
    </div>
  );
}
